<!--
 * @Description: 泵管外包
 * @Autor: wangwangwang
 * @Date: 2021-01-28 20:05:18
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-08-10 16:26:52
-->
<template>
  <div class="table pumpTube">
    <div class="card">
      <div class="card_nav">
        <div>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加'), reset()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'RIYONG') !== -1" size="small" class="bottom_three" @click="UpdateOrDelete('update_enable', 1)">
            <i class="icon iconfont iconicon_button_startuse" style="font-size: 12px"></i>
            启用
          </el-button>
          <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'JINYONG') !== -1" size="small" class="bottom_four" @click="UpdateOrDelete('update_enable', 0)">
            <i class="icon iconfont iconicon_button_disable1" style="font-size: 12px"></i>
            禁用
          </el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'TIAOJIA')" size="small" class="botton_five" :disabled="yiFenPeiRadio == ''" @click="riseInPriceQueryOneByidFun(yiFenPeiRadio)">调价</el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'KAIHUXINXI')" size="small" class="botton_five" :disabled="yiFenPeiRadio == ''" @click="queryListsByPidFun(yiFenPeiRadio)">开户信息</el-button>
          <el-button v-if="ButtonList.some(res => res.buttonValue == 'FENPEIZHANGHAO')" size="small" class="botton_five" :disabled="yiFenPeiRadio == ''" @click="open(yiFenPeiRadio, 'dialog1')">分配账号</el-button>
        </div>
        <div>
          <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
            <el-link :underline="false">
              <span class="el-icon--left">
                <i class="iconfont iconicon_button_filtrate"></i>
              </span>
              筛选
            </el-link>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in table" :key="index">
                <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link v-if="ButtonList.findIndex(res => res.buttonValue == 'DAOCHU') !== -1" :underline="false" @click="load()">
            <span class="el-icon--left">
              <i class="iconfont iconicon_button_export1"></i>
            </span>
            导出
          </el-link>
        </div>
      </div>
      <div v-loading="tableLoading" class="card_info">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
            <template slot-scope="scope">
              <el-radio v-model="yiFenPeiRadio" :label="scope.row">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <template v-for="(item, index2) in table">
            <el-table-column v-if="item.label == '操作'" :key="index2" fixed="right" :label="item.label" align="center" :width="item.width">
              <template slot-scope="scope">
                <el-dropdown :hide-on-click="false" trigger="click">
                  <el-button size="mini" class="bottom_one">更多</el-button>
                  <el-dropdown-menu slot="dropdown" style="text-align: left">
                    <el-dropdown-item v-if="ButtonList.some(res => res.buttonValue == 'XIUGAI')">
                      <el-button style="margin: 5px 0" class="bottom_one" size="mini" @click="contractQueryDetailByIdFun(scope.row.id), (addDialogTitle = '修改'), (modifyType = false)"> 修改 </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-button size="mini" style="margin: 5px 0" class="bottom_one" @click="$refs.ModifyTheRecord.contractQueryPageContractLogFun(scope.row.id)">更改记录</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
              <template slot-scope="scope">
                <div v-if="item.label == '状态'">
                  <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
                  <span v-else-if="scope.row.enable == 1" style="color: #00a754">启用</span>
                </div>
                <el-link v-else-if="item.label == '合同ID'" class="table_link" :underline="false" @click="contractQueryDetailByIdFun(scope.row.id), (addDialogTitle = '查看')">{{ scope.row.code }}</el-link>
                <div v-else-if="item.label == '站点名称'">
                  <span>{{ scope.row.stations | stationsFun }}</span>
                </div>
                <el-link v-else-if="item.label == '协作单位'" class="table_link" :underline="false" @click="cooperativeUnitFun(scope.row)">协作单位</el-link>
                <div v-else-if="item.label == '合同签订情况'">
                  <span v-if="scope.row.concludeAndSignStatus == 1">已签订</span>
                  <span v-else>未签订</span>
                </div>
                <div v-else-if="item.label == '华西云采注册情况'">
                  <span v-if="scope.row.loginStatus == 1">已注册</span>
                  <span v-else>未注册</span>
                </div>
                <div v-else-if="item.label == '合同有效期'">{{ scope.row.startDay + " - " + scope.row.endDay }}</div>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData(), (yiFenPeiRadio = '')"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </div>
    <!-- 添加·合同 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="1015px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo FZYform scroll" style="height: calc(85vh - 230px); padding-right: 5px; overflow: auto">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="formDate" label-width="110px">
          <div class="form-title">基本信息</div>
          <el-form-item prop="firstPartyId">
            <span slot="label">权限公司</span>
            <el-select
              ref="selection1"
              v-model="formDate.firstPartyId"
              placeholder="请选择"
              :disabled="modifyType"
              @change="
                companylistChangeFun(true, formDate.firstPartyId),
                  $nextTick(() => {
                    formDate.firstParty = $refs.selection1.selectedLabel;
                  })
              "
            >
              <el-option v-for="(item, index) in companylist" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contractSigningSubjectId">
            <span slot="label">合同签订主体</span>
            <el-select
              ref="selection1"
              v-model="formDate.contractSigningSubjectId"
              placeholder="请选择"
              :disabled="modifyType"
              @change="
                $nextTick(() => {
                  formDate.contractSigningSubject = $refs.selection1.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in roadWorkList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="stationsList">
            <span slot="label">站点名称</span>
            <el-select v-model="formDate.stationsList" placeholder="请选择" multiple :disabled="modifyType">
              <el-option v-for="(item, index) in sitelist" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="supplierId">
            <span slot="label">主合同单位</span>
            <el-select
              ref="selection2"
              v-model="formDate.supplierId"
              filterable
              placeholder="请选择"
              :disabled="modifyType"
              @change="
                changemainCompanyId(formDate.supplierId),
                  $nextTick(() => {
                    formDate.supplierName = $refs.selection2.selectedLabel;
                  })
              "
            >
              <el-option v-for="(item, index) in supplierList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contractNumber">
            <span slot="label">合同编号</span>
            <el-input v-model="formDate.contractNumber" placeholder="请输入" clearable :disabled="modifyType" @blur="queryContractNumberFun()"></el-input>
          </el-form-item>
          <el-form-item prop="callForBidsNumber">
            <span slot="label">招标编号</span>
            <el-input v-model="formDate.callForBidsNumber" placeholder="请输入" clearable :disabled="modifyType"></el-input>
          </el-form-item>
          <el-form-item prop="concludeAndSignStatus">
            <span slot="label">合同签订情况</span>
            <el-select v-model="formDate.concludeAndSignStatus" placeholder="请选择" :disabled="modifyType">
              <el-option label="已签订" :value="1"></el-option>
              <el-option label="未签订" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="loginStatus" label-width="140px">
            <span slot="label">华西云采注册情况</span>
            <el-select v-model="formDate.loginStatus" class="hyyc" placeholder="请选择" :disabled="modifyType">
              <el-option label="已注册" :value="1"></el-option>
              <el-option label="未注册" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="linkman">
            <span slot="label">联系人</span>
            <el-input v-model="formDate.linkman" placeholder="请输入" clearable :disabled="modifyType"></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <span slot="label">联系电话</span>
            <el-input v-model="formDate.phone" placeholder="请输入" clearable :disabled="modifyType"></el-input>
          </el-form-item>
          <el-form-item prop="startDayendDay">
            <span slot="label">合同有效期</span>
            <el-date-picker
              v-model="formDate.startDayendDay"
              unlink-panels
              style="width: 340px"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="modifyType"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="taxRate">
            <span slot="label">税率</span>
            <el-select v-model="formDate.taxRate" placeholder="请选择" style="width: 340px" :disabled="modifyType">
              <el-option v-for="(item, index) in taxRateList" :key="index" :label="item.itemName" :value="item.itemValue"></el-option>
            </el-select>
          </el-form-item>
          <div class="form-title">单价相关</div>
          <div>
            <div style="padding-bottom: 10px">
              <el-button size="mini" class="bottom_all" style="margin-left: 0" :disabled="modifyType" @click="addItemPumpList()">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="pumpListArr" tooltip-effect="dark" class="FZYselectList">
              <el-table-column label="泵车类型" align="center" width="250">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.pumpTypeId" size="mini" placeholder="选择" :disabled="modifyType" style="width: 100% !important" @change="pumpTypeId_pumpTypeFun(scope.row, scope.$index)">
                    <el-option v-for="item in pumpTypeArr" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="基础单价（元/方）" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.price" type="Number" size="mini" style="width: 100%" placeholder="输入价格" :disabled="modifyType" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="left" prop="specification">
                <template slot-scope="scope">
                  <el-button size="mini" class="bottom_two" :disabled="modifyType" @click="deleteItemPumpList(scope.$index)">
                    <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="form-title">结算规则</div>
          <el-form-item prop="clearingFormId">
            <span slot="label">结算方式</span>
            <el-select v-model="formDate.clearingFormId" placeholder="请选择" :disabled="modifyType">
              <el-option v-for="(item, index) in clearingFromIdList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="paymentMethod" :rules="[{ required: true, message: '请选择付款方式', trigger: 'change' }]">
            <span slot="label">付款方式</span>
            <el-select v-model="formDate.paymentMethod" placeholder="请选择" :disabled="modifyType">
              <el-option label="账龄" :value="1"></el-option>
              <el-option label="比例" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="formDate.paymentMethod == 1" prop="aging" :rules="[{ required: formDate.paymentMethod == 1, message: '请选择账龄', trigger: 'change' }]">
            <span slot="label">账龄</span>
            <el-select v-model="formDate.aging" placeholder="请选择" :disabled="modifyType">
              <el-option label="1月" :value="1"></el-option>
              <el-option label="2月" :value="2"></el-option>
              <el-option label="3月" :value="3"></el-option>
              <el-option label="4月" :value="4"></el-option>
              <el-option label="5月" :value="5"></el-option>
              <el-option label="6月" :value="6"></el-option>
              <el-option label="7月" :value="7"></el-option>
              <el-option label="8月" :value="8"></el-option>
              <el-option label="9月" :value="9"></el-option>
              <el-option label="10月" :value="10"></el-option>
              <el-option label="11月" :value="11"></el-option>
              <el-option label="12月" :value="12"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="formDate.paymentMethod == 2" prop="paymentRatio" :rules="[{ required: formDate.paymentMethod == 2, message: '请输入支付比例', trigger: 'change' }]">
            <span slot="label">支付比例(%)</span>
            <el-input-number v-model="formDate.paymentRatio" :precision="2" style="width: 130px" :max="100" :disabled="modifyType" :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item>
            <span slot="label">结算说明</span>
            <el-input v-model="formDate.explains" style="width: 800px" type="textarea" placeholder="请输入" clearable :rows="2" resize="none" :disabled="modifyType" maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <div class="form-title">附件</div>
          <FileComponent fileCode="pumptubeFile" :disabled="modifyType" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addDialog = false">关 闭</el-button>
        <el-button v-show="!modifyType" class="bottom_all" style="margin-left: 24px" :disabled="modifyType" @click="pagessubmitFromDate()">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 站点运输价及到岸价查看 -->
    <el-dialog v-dialogDrag :visible.sync="thePrice_Dialog" width="550px">
      <span slot="title" class="dialog-title">站点运输价及到岸价</span>
      <div class="dialoginfo"></div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="thePrice_Dialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 协作单位 -->
    <el-dialog v-dialogDrag :visible.sync="cooperativeUnit_Dialog" width="550px">
      <span slot="title" class="dialog-title">协作单位</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="cooperativeUnitArr" tooltip-effect="dark">
          <el-table-column label="协作单位" align="center" prop="name"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="cooperativeUnit_Dialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 合同产品列表 -->
    <el-dialog v-dialogDrag :visible.sync="riseInPriceQueryOneByidType" width="800px">
      <span slot="title" class="dialog-title">合同产品列表</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="pumpListArr" tooltip-effect="dark" class="FZYselectList">
          <el-table-column label="设备" align="center" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.pumpTypeId" size="mini" placeholder="选择" disabled style="width: 100% !important">
                <el-option v-for="item in pumpTypeArr" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="基础单价（元/方）" align="center">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="QueryOneByidFun(scope.row, true)">价格设置</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="riseInPriceQueryOneByidType = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 价格设置-调价详情 -->
    <el-dialog v-dialogDrag :visible.sync="QueryOneByidType" width="800px">
      <span slot="title" class="dialog-title">价格设置</span>
      <div class="dialoginfo">
        <el-form ref="contractRawMoneySaveForm" label-width="80px" :model="contractRawMoneySaveForm" :rules="contractRawMoneySaveFormRules" class="FZYform2">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="价格" prop="money">
                <el-input v-model="contractRawMoneySaveForm.money" type="Number" placeholder>
                  <template slot="append">元/吨</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生效日期" prop="startTime">
                <el-date-picker v-model="contractRawMoneySaveForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div style="margin-left: 24px"><FileComponent2 fileCode="contractFile" :files="files2" @deleteFile="deleteFile2" @uplodeSuccess="uplodeSuccess2" /></div>
            </el-col>
            <el-col :span="2" style="margin-bottom: 20px">
              <el-button class="bottom_all" @click="contractRawMoneySaveFun()">添加</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="QueryOneByidArr" tooltip-effect="dark">
          <el-table-column label="价格" prop="money" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.money }} 元/吨</span>
            </template>
          </el-table-column>
          <el-table-column label="生效日期" prop="startTime" align="center"></el-table-column>
          <el-table-column label="附件" align="center" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_all_two" @click="lookFile(scope)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="contractRawMoneyDeletesFun(scope.row.id)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ QueryOneByidObject.total }}条</div>
            <el-pagination
              :current-page.sync="QueryOneByidObject.page"
              :page-size="QueryOneByidObject.pageSize"
              layout="prev, pager, next, jumper"
              :total="QueryOneByidObject.total"
              @current-change="QueryOneByidFun()"
            ></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="QueryOneByidType = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 开户信息 -->
    <el-dialog v-dialogDrag :visible.sync="AllqueryListsByPid" width="550px">
      <span slot="title" class="dialog-title">开户信息维护</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="queryListsByPidArr" tooltip-effect="dark">
          <el-table-column label="单位名称" prop="name" align="center"></el-table-column>
          <el-table-column label="开户信息">
            <template slot-scope="scope">
              <el-link class="table_link" :underline="false" @click="contractAccountGetDetailFun(scope.row.id, scope.$index + 1)">开户信息</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="AllqueryListsByPid = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 开户信息详情-编辑 -->
    <el-dialog v-dialogDrag :visible.sync="contractAccountGetDetailType" width="800px">
      <span slot="title" class="dialog-title">开户信息</span>
      <div class="dialoginfo">
        <el-form ref="contractAccountSaveForm" label-width="130px" :model="contractAccountSaveForm" :rules="contractAccountSaveRules" class="FZYform2">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="法定代表人" prop="name" :rules="[{ required: true, message: '请输入法定人', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人身份证号码" prop="identityCard">
                <el-input v-model="contractAccountSaveForm.identityCard"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="合同条款" prop="contractPact" :rules="[{ required: true, message: '请输入合同条款', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.contractPact"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode" :rules="[{ required: true, message: '请输入信用代码', trigger: 'blur' }]">
                <el-input v-model="contractAccountSaveForm.unifiedSocialCreditCode"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">现金</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositA"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountA"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberA"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">电子承兑</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositB"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountB"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberB"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">商票</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositC"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountC"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberC"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="收款方式">
                <div style="width: 100px">其他</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位开户银行">
                <el-input v-model="contractAccountSaveForm.bankDepositD"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单位开户账号">
                <el-input v-model="contractAccountSaveForm.accountD"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行联行号">
                <el-input v-model="contractAccountSaveForm.bankNumberD"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="contractAccountGetDetailType = false">关 闭</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="contractAccountSaveFun()">保 存</el-button>
      </span>
    </el-dialog>
    <ModifyTheRecord ref="ModifyTheRecord"></ModifyTheRecord>
    <diaLog1 :dialog="dialog1" :low="low" :supplierId="supplierId" :tableData="roleList" @reset="reset1" @submit="submit"></diaLog1>
    <!-- 查看附件 -->
    <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
  </div>
</template>

<script>
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import LookFile from "@/components/File/LookFile";
import mixin from "@/mixins/ICPSmixin.js";
import FileComponent from "@/components/File/fileComponent";
import {
  queryPage,
  batchUpdateOrDelete,
  updateSortNum,
  saveOrUpdate,
  Download,
  // engineeringManagementQueryPage,
  contractSaveOrUpdate,
  contractQueryDetailById,
  QueryOneByid,
  contractRawMoneySave,
  contractRawMoneyDeletes,
  contractAccountGetDetail,
  contractAccountSave,
  queryContractNumber,
} from "@/api/GHnumber/car.js";
import { querysupplierPage, queryListsByPid } from "@/api/GHnumber/supplier.js";
import { queryMaterialsPage } from "@/api/basicConfig/Rmaterial.js";
import { getDicType } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth.js";
import { getUserAutList } from "@/api/common.js";
import ModifyTheRecord from "./modifyTheRecord";
import { getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
const diaLog1 = () => import("../dialog/contract1");
export default {
  components: { FileComponent, ModifyTheRecord, diaLog1, FileComponent2, LookFile },
  mixins: [mixin],
  watch: {
    "formDate.startDayendDay"() {
      this.formDate.startDay = this.formDate.startDayendDay[0];
      this.formDate.endDay = this.formDate.startDayendDay[1];
    },
    yiFenPeiRadio: {
      handler: function (val) {
        this.ids = [val.id];
      },
      deep: false,
    },
  },
  data() {
    var userCard = (rule, value, callback) => {
      //验证身份证号码
      var reg = new RegExp(/^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/);
      if (!reg.test(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    };
    return {
      //分配账号角色列表
      roleList: [
        { roleName: "泵管外包接单员", roleId: "194993730833485824", list: [], list1: [] },
        { roleName: "泵管外包签票员", roleId: "194994415809466368", list: [], list1: [] },
        { roleName: "泵管外包结算员", roleId: "194995131642941440", list: [], list1: [] },
        { roleName: "泵管外包异常处理员", roleId: "194995999796760576", list: [], list1: [] },
      ],
      roadWorkList: [], // 合同签订主体数据
      lookFileVisible: false,
      lookFileConfig: {},
      low: "",
      dialog1: false,
      files: [],
      files2: [],
      UserInfo: "",
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      batchUpdateOrDelete: batchUpdateOrDelete, //启用禁用接口
      updateSortNum: updateSortNum,
      saveOrUpdate: saveOrUpdate,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "合同ID", width: "120", prop: "code", status: true },
        { label: "合同类型", width: "120", prop: "contractType", status: true },
        {
          label: "合同签订主体",
          width: "auto",
          prop: "contractSigningSubject",
          status: true,
        },
        {
          label: "乙方公司",
          width: "auto",
          prop: "supplierName",
          status: true,
        },
        {
          label: "站点名称",
          width: "auto",
          prop: "stations",
          status: true,
        },
        {
          label: "合同编号",
          width: "auto",
          prop: "contractNumber",
          status: true,
        },
        {
          label: "合同签订情况",
          width: "auto",
          prop: "concludeAndSignStatus",
          status: true,
        },
        {
          label: "华西云采注册情况",
          width: "120",
          prop: "loginStatus",
          status: true,
        },
        { label: "合同有效期", width: "145", prop: "startDay", status: true },
        {
          label: "合作等级",
          width: "auto",
          prop: "cooperationClass",
          status: true,
        },
        { label: "状态", width: "120", prop: "", status: true },
        { label: "操作", width: "100", prop: "", status: true, fixed: "right" },
      ],
      modifyType: false, //修改是否可以状态
      text: "含水率规则：0≤x≤5%，按照5%结算；5%＜X≤8%，按照8%结算；8%<x≤13%，按照实测结算；13%<x，按照实测结算，并5元/吨处罚",
      clearingFromIdList: [
        // { id: '0', name: '双控' },
        // { id: '1', name: '图算' },
        { id: "2", name: "实结" },
      ], //结算方式
      companylist: [], //甲方公司
      sitelist: [], //站点名称
      supplierList: [], //主合同单位名称
      MaterialsList: [], //原物料
      AForContract: [], //是否甲供合同
      theUnitPriceSource: [
        {
          id: "1",
          itemName: "已信息价结算",
        },
        {
          id: "2",
          itemName: "已内部价结算",
        },
        {
          id: "3",
          itemName: "已市场价结算",
        },
        {
          id: "4",
          itemName: "已出厂价结算",
        },
        {
          id: "5",
          itemName: "已到岸价结算",
        },
      ], //单价来源
      engineeringManagement: [], //甲供工程
      thePrice_Dialog: false, //价格表弹窗
      controlPoint_Dialog: false, //业务管控点弹窗
      cooperativeUnit_Dialog: false, //协作单位弹窗
      rules: {
        firstPartyId: [{ required: true, message: "请选择甲方公司", trigger: "change" }],
        contractSigningSubjectId: [{ required: true, message: "请选择合同签订主体", trigger: "change" }],
        stationsList: [{ required: true, message: "请选择站点", trigger: "change" }],
        supplierId: [{ required: true, message: "请选择主合同单位", trigger: "change" }],
        contractNumber: [{ required: true, message: "请输入合同编号", trigger: "change" }],
        callForBidsNumber: [{ required: true, message: "请输入招标编号", trigger: "change" }],
        concludeAndSignStatus: [{ required: true, message: "请选择合同签订情况", trigger: "change" }],
        loginStatus: [
          {
            required: true,
            message: "请选择华西云采注册情况",
            trigger: "change",
          },
        ],
        linkman: [{ required: true, message: "请输入联系人", trigger: "change" }],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "change" },
          { min: 11, max: 11, message: "手机号格式错误", trigger: "change" },
        ],
        startDayendDay: [{ required: true, message: "请选择合同有效期", trigger: "change" }],
        clearingFormId: [{ required: true, message: "请选择结算方式", trigger: "change" }],
        processModel: [{ required: true, message: "请选择流程模式", trigger: "change" }],
        taxRate: [{ required: true, message: "请输入税率", trigger: "change" }],
      },
      formDate: {
        userType: [],
        stationsList: [],
        stations: "",
        startDayendDay: [],
        id: "",
        contractTypeId: "4",
        contractType: "泵管外包",
        deviceId: 1,
        firstParty: "", //甲方
        contractSigningSubjectId: "", // 合同签订主体
        supplierName: "", //供应商
        supplierTypeId: "", //供应商类型id
        userId: "",
        userName: "",
        firstSupplyName: "", //甲供合同
        clearingSource: "", //结算原
        clearingForm: "", //结算方式
        accessory: [], //附件
        cooperationClass: "合作等级", //甲方公司里面出来的
        cooperationClassId: "合作等级id", //甲方公司里面出来的
        pumpList: [], //泵车表格价格
      },
      businessCheckbox: [], //业务点
      cooperativeUnitArr: [], //外协单位列表
      riseInPriceQueryOneByidType: false,
      riseInPriceQueryOneByidArr: [], //调价列表
      contractId: "", //原物料列表
      QueryOneByidType: false,
      QueryOneByidArr: [], //调价列表
      pumpTypeArr: [], //泵管类型
      cargoTypeIdArr: [
        {
          id: 1,
          name: "原物料",
        },
        {
          id: 2,
          name: "混凝土",
        },
        {
          id: 3,
          name: "其他",
        },
      ],
      QueryOneByidObject: {
        //调价分页
        page: 1,
        pageSize: 10,
        total: 0,
      },
      contractRawMoneySaveForm: { startTime: "" },
      contractRawMoneySaveFormRules: {
        money: [{ required: true, message: "请输入价格", trigger: "blur" }],
        startTime: [{ required: true, message: "请选择生效日期", trigger: "blur" }],
      },
      AllqueryListsByPid: false,
      queryListsByPidArr: [], //开户信息-协作单位合并列表
      contractAccountGetDetailType: false,
      //开户信息表单
      contractAccountSaveForm: {
        contractPactId: "", //合同条约id
        contractPact: "", //合同条约
      },
      contractAccountSaveRules: {
        identityCard: [{ required: true, validator: userCard, trigger: "change" }], //身份证
      },
      columnList: "泵送高度",
      carTwosArr: [], //区间价格弹窗数组
      carTwosArrIndex: "", //当前打开的价格弹窗数组对应的表格里面的下标
      basePriceListType: false, //设置区间价格弹窗
      pumpListArr: [], //泵管价格
      appPackage: [],
      yiFenPeiRadio: "",
      supplierId: "",
      taxRateList: [],
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.companylist = await getUserAutList();
    const arr = this.companylist.map(item => item.children);
    arr.forEach(item => {
      item.forEach(sItem => {
        this.sitelist.push(sItem);
      });
    });
    let params = {
      page: 1,
      pageSize: 99999,
    };
    // engineeringManagementQueryPage({
    //   isAssess: 1,
    //   page: 1,
    //   pageSize: 99999,
    // }).then(res => {
    //   this.engineeringManagement = res.data.data;
    // });
    getDicType({ code: "pumpTube" }).then(res => {
      this.pumpTypeArr = res.data.items;
      console.log(JSON.parse(JSON.stringify(this.pumpTypeArr)));
    });
    querysupplierPage(params).then(res => {
      this.supplierList = res.data.data;
    });
    queryMaterialsPage().then(res => {
      this.MaterialsList = res.data;
    });
    getDicType({ code: "contractType" }).then(res => {
      this.contractTypeArry = res.data.items; //
    });
    getDicType({ code: "HuaXiYunCai_Registration" }).then(res => {
      this.HuaXiYunCai_RegistrationArry = res.data.items; //
    });
    getDicType({ code: "AForContract" }).then(res => {
      this.AForContract = res.data.items; //
    });
    getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
      if (res.code === 1001) {
        this.roadWorkList = res.data;
      }
    });
    getDicType({ code: "hetongsuilv" }).then(res => {
      this.taxRateList = res.data.items;
      this.taxRateList.forEach(item => {
        item.itemValue = Number(item.itemValue);
      });
    });
  },
  methods: {
    lookFile({ row }) {
      this.lookFileVisible = true;
      this.lookFileConfig = row;
    },
    /**分配账号*/
    open(low, key) {
      this.supplierId = low.supplierId;
      this.low = low.id;
      this[key] = true;
    },
    reset1(key) {
      this[key] = false;
    },
    submit(key) {
      this[key] = false;
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    deleteFile2(index) {
      this.files2.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      this.files.push(data);
    },
    uplodeSuccess2(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files2.push(params);
    },
    addJson() {
      //价格区间添加
      this.carTwosArr.push({
        id: "",
        singleDistance: 1, //距离
        singleDistancePrice: 0, //价格
        type: 1, //1新增；2修改 0删除
      });
      this.$forceUpdate();
    },
    delJson(k) {
      //价格区间删除
      this.carTwosArr.splice(k, 1);
      this.$forceUpdate();
    },
    //泵列表选择后赋值泵类型
    pumpTypeId_pumpTypeFun(e, k) {
      let type = false;
      this.pumpListArr.findIndex((v, index) => {
        if (v.pumpTypeId == e.pumpTypeId && k != index) {
          type = true;
        }
      });
      if (type) {
        this.$message({
          message: "该泵管类型已存在！",
          type: "warning",
        });
        e.pumpTypeId = "";
        return;
      }
      this.pumpListArr[k].pumpType = this.$fromatTable(this.pumpTypeArr, e.pumpTypeId, "id", "itemName");
    },
    //泵列表添加一条数据
    addItemPumpList() {
      this.pumpListArr.push({
        id: "",
        pumpType: "", //泵类型
        pumpTypeId: "", //泵类型id
        price: 0, //价格
        type: 1,
      });
      this.$forceUpdate();
    },
    deleteItemPumpList(index) {
      this.pumpListArr.splice(index, 1);
    },
    //选择甲方公司后显示对应站点名称
    companylistChangeFun(type, companyId) {
      if (type) {
        this.formDate.stationsList = [];
      }
      this.sitelist = this.companylist.find(res => res.value == companyId).children;
    },
    //调用父级init
    init() {
      this.$emit("sumbit");
    },
    initt(data) {
      /*重置数据*/
      this.tableParam = data;
      this.gettableData();
    },
    srarch(data) {
      this.tableParam = data;
      this.gettableData();
    },
    //主合同单位选择后，带出对应参数
    async changemainCompanyId(e) {
      let item = this.supplierList.find(res => res.id == e);
      this.formDate.supplierType = item.typeName;
      this.formDate.supplierTypeId = item.typeId;
    },
    /*添加保存*/
    pagessubmitFromDate() {
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          let type = false;
          this.pumpListArr.forEach(v => {
            if (!v.pumpTypeId) {
              type = true;
            }
          });
          if (type) {
            this.$message({
              message: "请检查表格数据是否完整！",
              type: "warning",
            });
            return;
          }
          //泵管价格数据重组2-开始
          if (this.pumpListArr.length > 0 && this.formDate.pumpList.length > 0) {
            let alldata = this.pumpListArr.filter(res => this.formDate.pumpList.some(item => res.id == item.id));
            alldata.forEach(res => {
              res.type = 2; //0是删除
            });
            let deleteData = this.formDate.pumpList.filter(res => !alldata.some(item => res.id == item.id));
            deleteData.forEach(res => {
              res.type = 0; //0是删除
            });
            let addData = this.pumpListArr.filter(res => !alldata.some(item => res.id == item.id));
            this.formDate.pumpList = [...alldata, ...deleteData, ...addData];
          } else {
            this.formDate.pumpList = this.pumpListArr;
          }
          //泵管价格数据重组2-结束
          this.formDate.supplierName = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "name");
          this.formDate.supplierTypeId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "typeId");
          this.formDate.clearingSource = this.$fromatTable(this.theUnitPriceSource, this.formDate.clearingSourceId, "id", "itemName");
          this.formDate.clearingForm = this.$fromatTable(this.clearingFromIdList, this.formDate.clearingFormId, "id", "name");
          this.formDate.cooperationClass = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "gradeName");
          this.formDate.cooperationClassId = this.$fromatTable(this.supplierList, this.formDate.supplierId, "id", "gradeId");
          if (this.formDate.accessory.length != 0) {
            this.formDate.accessory = JSON.stringify(this.formDate.accessory);
          } else {
            this.formDate.accessory = "";
          }
          //站点数据重装-开始
          if (this.formDate.stationsList.length > 0) {
            let arr = [];
            this.formDate.stationsList.forEach(v => {
              this.sitelist.forEach(v2 => {
                if (v == v2.value) {
                  arr.push({
                    id: v,
                    name: v2.label,
                  });
                }
              });
            });
            this.formDate.stations = arr;
          }
          this.formDate.stations = JSON.stringify(this.formDate.stations);
          this.formDate.accessory = JSON.stringify(this.files);
          //站点数据重装-结束
          contractSaveOrUpdate(this.formDate).then(res => {
            if (res.code == 1001) {
              this.addDialog = false;
              this.$message.success("操作成功");
              this.init();
            }
          });
        } else {
          this.$message({
            message: "必填字段填写不完全！",
            type: "warning",
          });
          return false;
        }
      });
    },
    //获取合同详情
    contractQueryDetailByIdFun(d) {
      if (this.$refs.reffromDate) {
        this.$refs.reffromDate.resetFields();
      }
      this.addDialog = true;
      this.modifyType = true;
      contractQueryDetailById({ id: d }).then(async res => {
        this.formDate = { ...this.formDate, ...res.data.contract };
        this.changemainCompanyId(this.formDate.supplierId, true);
        this.formDate.startDayendDay = [];
        this.formDate.startDayendDay[0] = this.formDate.startDay;
        this.formDate.startDayendDay[1] = this.formDate.endDay;
        this.formDate.pumpList = this.copy(res.data.list);
        this.pumpListArr = this.copy(res.data.list);
        this.files = JSON.parse(this.formDate.accessory) || [];
        await this.companylistChangeFun(false, this.formDate.firstPartyId); //选择甲方公司后显示对应站点名称
        if (this.formDate.accessory != null) {
          this.formDate.accessory = JSON.parse(this.formDate.accessory);
        } else {
          this.formDate.accessory = [];
        }
        //判断公司-站点权限是否包含返回的详情id值，在就回显，不在就回显提示信息placeholder
        let type1 = this.companylist.findIndex(res => res.value == this.formDate.firstPartyId);
        if (type1 == -1) {
          this.formDate.firstPartyId = "";
          this.formDate.firstPartyIdPlaceholder = this.formDate.firstParty;
          let text = "";
          JSON.parse(this.formDate.stations).forEach(v => {
            text = text + v.name + " ";
          });
          this.formDate.stations = "";
          this.formDate.stationsList = [];
          this.formDate.stationsPlaceholder = text;
        } else {
          if (this.formDate.stations) {
            let arr1 = [];
            JSON.parse(this.formDate.stations).forEach(v => {
              arr1.push(v.id);
            });
            this.formDate.stationsList = arr1;
          } else {
            this.formDate.stationsList = [];
          }
        }
        this.$forceUpdate();
        console.log(JSON.parse(JSON.stringify(this.formDate)));
      });
    },
    //调价列表
    riseInPriceQueryOneByidFun(d) {
      this.contractId = d.id;
      this.riseInPriceQueryOneByidType = true;
      contractQueryDetailById({ id: d.id }).then(async res => {
        this.formDate = res.data.contract;
        this.pumpListArr = this.copy(res.data.list);
        console.log(JSON.parse(JSON.stringify(this.pumpListArr)));
      });
    },
    //价格设置-调价详情-列表
    QueryOneByidFun(d) {
      this.QueryOneByidType = true;
      this.QueryOneByidArr = [];
      this.contractRawMoneySaveForm.startTime = "";
      this.QueryOneByidObject.contractId = this.contractId;
      if (d) {
        this.QueryOneByidObject.rawId = d.id;
        this.carTwosArr = d.list;
      }
      QueryOneByid(this.QueryOneByidObject).then(res => {
        this.QueryOneByidArr = res.data.data;
        this.QueryOneByidObject.total = res.data.totalRows;
      });
    },
    //价格设置，提交
    contractRawMoneySaveFun() {
      if (!this.files2?.length) {
        return this.$message.warning("请上传附件文件");
      }
      this.$refs.contractRawMoneySaveForm.validate(valid => {
        if (valid) {
          this.contractRawMoneySaveForm.contractId = this.contractId;
          this.contractRawMoneySaveForm.rawId = this.QueryOneByidObject.rawId;
          this.contractRawMoneySaveForm.contractFacility = this.QueryOneByidObject.rawId;
          this.contractRawMoneySaveForm.list = this.carTwosArr;
          this.contractRawMoneySaveForm.filePaths = JSON.stringify(this.files2);
          //泵管价格用
          contractRawMoneySave(this.contractRawMoneySaveForm).then(res => {
            if (res.code == 1001) {
              this.QueryOneByidFun();
            }
          });
        } else {
          return false;
        }
      });
    },
    //删除价格
    contractRawMoneyDeletesFun(d) {
      contractRawMoneyDeletes({ id: d }).then(() => {
        this.QueryOneByidObject.page = 1;
        this.QueryOneByidFun();
      });
    },
    //协作单位-开户信息
    cooperativeUnitFun(d) {
      this.cooperativeUnit_Dialog = true;
      queryListsByPid({ supplierId: d }).then(res => {
        this.cooperativeUnitArr = res.data;
      });
    },
    //协作单位组合
    queryListsByPidFun(d) {
      this.contractId = d.id;
      this.AllqueryListsByPid = true;
      console.log(d);
      queryListsByPid({ supplierId: d.supplierId }).then(res => {
        this.queryListsByPidArr = res.data;
        // let obj = {
        //   id: d.supplierId,
        //   name: d.supplierName,
        // };
        // this.queryListsByPidArr.splice(0, 0, obj);
      });
    },
    //开户信息详情
    contractAccountGetDetailFun(d) {
      this.contractAccountSaveForm = {};
      this.contractAccountGetDetailType = true;
      let obj = {
        contractId: d.id,
        pid: d.supplierId,
        type: 1,
      };
      contractAccountGetDetail(obj).then(res => {
        this.contractAccountSaveForm = res.data;
        this.$refs.contractAccountSaveForm.resetFields();
      });
    },
    //开户信息保存
    contractAccountSaveFun() {
      this.$refs.contractAccountSaveForm.validate(valid => {
        if (valid) {
          // this.formDate.contractPact = this.$fromatTable(
          //   this.contractPactIdArr,//未知
          //   this.formDate.contractPactId,
          //   "id",
          //   "name"
          // );
          contractAccountSave(this.contractAccountSaveForm).then(res => {
            if (res.code == 1001) {
              this.contractAccountGetDetailType = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    //重置表格-渲染
    reset() {
      this.modifyType = false;
      this.formDate = {
        startDayendDay: [],
        id: "",
        contractTypeId: "4",
        contractType: "泵管外包",
        firstParty: "", //甲方
        supplierName: "", //供应商
        supplierTypeId: "", //供应商类型id
        userId: "",
        userName: "",
        clearingSource: "", //结算原
        clearingForm: "", //结算方式
        accessory: [], //附件
        cooperationClass: "合作等级", //甲方公司里面出来的
        cooperationClassId: "合作等级id", //甲方公司里面出来的
        pumpList: [],
        taxRate: "", //税率
      };
      this.pumpListArr = [];
      this.files = [];
    },
    /**合同编号是否重复 */
    queryContractNumberFun() {
      queryContractNumber({ contractNumber: this.formDate.contractNumber, id: this.formDate.id }).then(res => {
        if (res.code == 1001 && !res.data) {
          this.$message({
            message: "合同编号重复！",
            type: "warning",
          });
          this.formDate.contractNumber = "";
        }
      });
    },
    handleAvatarSuccess1(res) {
      if (res.code === 1001) {
        console.log(res.data);
        this.appPackage = [];
        this.formDate.appPackage = res.data.fileName;
        this.formDate.accessory = res.data.fileUrl;
      }
    },
    beforeAvatarUpload1(file) {
      console.log(file);
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
  filters: {
    //站点list表格中拼接展示
    stationsFun(arr) {
      if (arr) {
        let ket = JSON.parse(arr).map(res => {
          return res.name;
        });
        return ket.join("、");
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  .el-input,
  .el-select {
    width: 230px;
  }
}
.el-input,
.el-select {
  width: 240px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
.FZYguanKongYeWuDian {
  display: flex;
  > table {
    flex: none;
    width: 100px;
  }
  > div {
    flex: 1;
  }
}
.FZY1-3 {
  border-bottom: 1px solid #f2f2f2;
  .liBox1,
  .liBox2 {
    padding: 10px;
    width: 520px;
    display: flex;
    > div:nth-of-type(1) {
      width: 210px;
    }
    > div:nth-of-type(2) {
      flex: 1;
    }
    span {
      display: inline-block;
      margin-left: 20px;
    }
    .el-input-number ::v-deep {
      margin-left: 20px;
    }
  }
  .liBox3 {
    padding: 10px;
    width: 650px;
    display: flex;
    > div:nth-of-type(1) {
      display: flex;
      > div:nth-of-type(1) {
        width: 210px;
        span {
          margin-left: 10px;
        }
        .el-input-number ::v-deep {
          margin-left: 10px;
          width: 80px;
        }
      }
      span {
        display: inline-block;
        margin-left: 20px;
      }
      .el-input-number ::v-deep {
        margin-left: 20px;
      }
    }
    > div:nth-of-type(2) {
      width: 130px;
      flex: none;
      line-height: 28px;
      padding-left: 20px;
    }
  }
}
</style>
<style lang="scss">
.pumpTube {
  .FZYcheckbox {
    .el-checkbox {
      min-width: 155px;
      margin-right: 0px;
    }
  }
  .FZYform {
    padding-top: 0px !important;
    .el-form-item {
      min-width: 445px;
      .el-input,
      .el-select {
        width: 340px;
      }
      .hyyc {
        width: 310px;
        .el-input {
          width: 310px;
        }
      }
    }
  }
  .FZYform2 {
    .el-form-item__error {
      white-space: nowrap;
    }
  }
  .FZYselectList {
    .el-select {
      width: 85px !important;
      margin-right: 10px;
    }
  }
}
</style>
